import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A utility-scale battery storage unit: two container-sized enclosures with
// ribbed cooling panels and roof vents on a concrete pad, beside a smaller
// inverter cabinet that ties them to the grid. The "megapack" that firms up
// renewables.
const PACK = "#c2c6cd";
const PACK_DK = "#9aa0a6";
const RIB = "#aab0b6";
const PAD = "#6f6f74";
const INV = "#878e96";
const VENT = "#5a6066";

function pack(cx: number): Part[] {
  const out: Part[] = [
    { geometry: new THREE.BoxGeometry(0.8, 0.62, 0.5), color: PACK, position: [cx, 0.41, 0] },
    { geometry: new THREE.BoxGeometry(0.84, 0.06, 0.54), color: PACK_DK, position: [cx, 0.75, 0] },
    // Roof vents.
    { geometry: new THREE.BoxGeometry(0.2, 0.06, 0.3), color: VENT, position: [cx - 0.2, 0.79, 0] },
    { geometry: new THREE.BoxGeometry(0.2, 0.06, 0.3), color: VENT, position: [cx + 0.2, 0.79, 0] },
  ];
  // Ribbed cooling panels across the long face.
  for (let i = 0; i < 6; i++) {
    out.push({ geometry: new THREE.BoxGeometry(0.04, 0.5, 0.04), color: RIB, position: [cx - 0.34 + i * 0.135, 0.41, 0.26] });
  }
  return out;
}

export const gridBattery = defineModel({
  id: "grid-battery",
  batchId: "electric",
  name: "Grid battery",
  tags: ["building", "electric", "power", "storage", "battery", "renewable"],
  summary: "Container-scale battery packs with an inverter, on a pad.",
  footprint: 1.0,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(2.6, 0.1, 0.9), color: PAD, position: [0.05, 0.05, 0] },
      ...pack(-0.72),
      ...pack(0.32),
      // Inverter / grid-tie cabinet on the end.
      { geometry: new THREE.BoxGeometry(0.34, 0.5, 0.4), color: INV, position: [1.04, 0.35, 0] },
      { geometry: new THREE.BoxGeometry(0.36, 0.05, 0.42), color: PACK_DK, position: [1.04, 0.62, 0] },
      { geometry: new THREE.BoxGeometry(0.24, 0.3, 0.02), color: "#5a6066", position: [1.04, 0.33, 0.21] },
      { geometry: new THREE.BoxGeometry(0.1, 0.06, 0.02), color: "#3aa0d0", position: [1.04, 0.5, 0.21] },
    ];
  },
  animations: [],
});
